export default "__VITE_ASSET__CUVfbY28__"